import Axios from 'axios';
import isEmpty from 'lodash/isEmpty';
const { isProduction } = require('../../server/scripts/utils')();

export function inviteListeners(
  invitees,
  subject,
  content,
  publisherId,
  publisherName,
  publisherImage,
  publisherEmail,
  plainEmail,
  bcc
) {
  Axios.post('/api/send_email_invites', {
    invitees,
    subject,
    content,
    publisherId,
    publisherName,
    publisherImage,
    publisherEmail,
    plainEmail, // if true, no not apply template
    bcc: isProduction() && !isEmpty(bcc) ? bcc : false, // add bcc email address
  })
    .then(res => {
      // console.log(res);
      return res;
    })
    .catch(err => {
      console.log('ERROR send emails to subscribers: ', err);
    });
}
